import { palette, TPalette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  categoriesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: anatomy['space-8'],
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    fontWeight: typography.fontWeighDemi,
    maxWidth: '100%',
    userSelect: 'none',
    alignSelf: 'center',
  },
  categoryItem: {
    color: palette['grey-950'],
    flex: '0 0 auto',
    padding: `${anatomy['space-8']} ${anatomy['space-16']}`,
    borderRadius: anatomy.borderRadiusRound,
    border: `1px solid ${palette['darked-40']}`,
  },
  categoryItemColored: (color: keyof TPalette) => ({
    background: palette[color],
    color: palette['greyWhite'],
    border: 'none',
    display: 'flex',
    alignItems: 'center',
  }),
});
